import { render, staticRenderFns } from "./UploadStudyMaterialModal.vue?vue&type=template&id=0ae12a49"
import script from "./UploadStudyMaterialModal.vue?vue&type=script&lang=js"
export * from "./UploadStudyMaterialModal.vue?vue&type=script&lang=js"
import style0 from "./UploadStudyMaterialModal.vue?vue&type=style&index=0&id=0ae12a49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports